import { render, staticRenderFns } from "./jy-palletPutOnList.vue?vue&type=template&id=ca3d6216&scoped=true&"
import script from "./jy-palletPutOnList.vue?vue&type=script&lang=js&"
export * from "./jy-palletPutOnList.vue?vue&type=script&lang=js&"
import style0 from "./jy-palletPutOnList.vue?vue&type=style&index=0&id=ca3d6216&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca3d6216",
  null
  
)

export default component.exports